import React, { cloneElement, Fragment, isValidElement, ReactNode } from 'react';
import styles from './styles.module.css';
// import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
// import SectionHeadMore from '@/components/pages/home/HomeContent/SampleBlogs/SectionHeadMore';
import PageCard from '@/components/general/PageCard';
import AppLink from '@/components/common/AppLink';
import MainIcons from '@/icons/main';
import BlogCard from '@/components/pages/home/HomeContent/SampleBlogs/BlogCard';
import BrandCard from '@/components/pages/brand/BrandsContent/BrandCard';
import ServiceSubCategoryComponent from '@/components/pages/home/HomeContent/HomeServices/ServiceGroup/ServiceSubCategoryComponent';
import { useSearchParams } from 'next/navigation';
import SearchSectionHead from './SearchSectionHead';
type SearchSectionItemProps = {
  item?: any;
  children?: (props: { f: any; index: number }) => ReactNode;
};

export default function SearchSectionItem({ item, children }: SearchSectionItemProps) {
  const searchParams = useSearchParams();

  // const href = `${item.href}?${searchParams.toString()}`;
  const params = new URLSearchParams(searchParams.toString());
  if (params.has('q')) {
    const q = params.get('q');

    params.delete('q');

    if (q) {
      params.set('search', q);
    }
  }

  const href = params.toString() ? `${item.href}?${params.toString()}` : item.href;
  console.log('item==', item);
  return (
    <div className={`${styles.section}`}>
      <SearchSectionHead item={item} href={href} />
      {item?.list && item?.list?.length != 0 ? (
        <div className={`${item?.gridClass}`}>
          {item?.list &&
            item?.list?.map((f: any, index: number) =>
              children ? (
                children({
                  f,
                  index,
                })
              ) : (
                <Fragment key={index}>
                  {item?.id == 'blogs' && <BlogCard item={f} />}
                  {item?.id == 'brands' && <BrandCard item={f} index={index} />}
                  {item?.id == 'services' && (
                    <ServiceSubCategoryComponent
                      it={{
                        ...f,
                        // image: {
                        //   name:
                        //     index == 0
                        //       ? '/imgs/motion/service/1.webp'
                        //       : index == 1
                        //         ? '/imgs/motion/service/1.webp'
                        //         : '/imgs/motion/service/2.webp',
                        // },
                      }}
                      index={index}
                      itemClass={`${styles.servieSubCategory}`}
                    />
                  )}
                </Fragment>
              ),
            )}
        </div>
      ) : (
        <p className={`card notFound w-full`}>موردی یافت نشد.</p>
      )}
    </div>
  );
}
